<!-- Tournament Casual Details -->
<div class="tournament-details">
  @if (details.data()) {
    <fz-banner
      [details]="details.data()"
      [hideMoreOptions]="true"
      [tournamentDetails]="details.data()"
      [actionBarConfig]="{ showTryForFreeButton: true }"
      (tryForFreePress)="onTryForFree()"
      (sharePress)="onShare($event)"
    ></fz-banner>
  } @else {
    <div class="banner-placeholder">
      <fz-skeleton
        viewBox="0 0 400 360"
        [speed]="2"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        class="container"
      >
        <svg:rect x="0" y="18" rx="3" ry="3" width="64" height="64" />

        <svg:rect x="72" y="22" rx="2" ry="3" width="30%" height="4" />
        <svg:rect x="72" y="30" rx="2" ry="3" width="15%" height="4" />
        <svg:rect x="72" y="38" rx="2" ry="3" width="25%" height="4" />

        <svg:rect x="72" y="58" rx="1" ry="1" width="20" height="2" />
        <svg:rect x="72" y="64" rx="1" ry="1" width="20" height="2" />

        <svg:rect x="72" y="72" rx="4" ry="4" width="56" height="10" />
        <svg:rect x="140" y="72" rx="4" ry="4" width="56" height="10" />
      </fz-skeleton>
    </div>
  }

  <div id="tabs" class="container">
    <fz-router-tabs
      [links]="tabsLinks"
      [activeLinkIndex]="view === 'tournaments' ? 0 : 1"
      type="query"
      [disableGutters]="true"
    ></fz-router-tabs>
  </div>
  <div class="container tournament-container">
    @if (view === 'tournaments') {
      <div>
        <div class="mb--2">
          @if (enabledFilters()) {
            <fz-filter-button
              class="mb--2"
              (filterChange)="onToggleFilter($event)"
            ></fz-filter-button>
          }
          <p class="hide-in-mobile">Select a row to view game play details</p>
        </div>
        <div class="table-list">
          @if (showFilterPanel() && events() && events().length > 0) {
            <fz-filter
              [arrayToFilter]="events()"
              (filterChange)="onFilterChange($event)"
              [model]="filterModel"
            ></fz-filter>
          }
          <div class="table-container" [class.filterOpened]="showFilter">
            @switch (details.status()) {
              @case ('pending') {
                <mat-card appearance="outlined">
                  <mat-card-content>
                    <fz-skeleton-table></fz-skeleton-table>
                  </mat-card-content>
                </mat-card>
              }
              @case ('error') {
                <mat-card appearance="outlined">
                  <mat-card-content>
                    {{ details.error()?.message }}
                  </mat-card-content>
                </mat-card>
              }
              @default {
                <fz-table-view
                  [schedules]="events()"
                  [tournamentDetails]="details.data() || null"
                  [currentUser]="currentUser()"
                  [isAuthenticated]="isAuthenticated() || false"
                  (shareSchedule)="onShare($event)"
                  (viewSchedule)="onView($event)"
                ></fz-table-view>
              }
            }
          </div>
        </div>

        <!-- Tournament Information -->
        <mat-card appearance="outlined" class="tournament-container__info">
          <div class="mat-headline-medium">Game Information</div>
          <div class="items">
            @for (info of information(); track $index) {
              <div class="item">
                <img src="/shared/svg/{{ info.icon }}" />
                <div>
                  <label class="label mat-label-large">{{ info.key }}:</label>
                  <p class="text">{{ info.value }}</p>
                </div>
              </div>
            }
          </div>
        </mat-card>
      </div>
    }
    <!-- My history tab -->
    @if (view === 'history') {
      @if (isUserLoggedIn() && details.data()?.eventPrototypeUuid) {
        <fz-my-history-tab
          [eventPrototypeUuid]="details.data()!.eventPrototypeUuid"
          (tryForFree)="onTryForFree()"
        ></fz-my-history-tab>
      } @else {
        <div class="inner-spacing">
          <fz-empty-list
            [isLoggedIn]="false"
            (loginEvent)="onLogin()"
          ></fz-empty-list>
        </div>
      }
    }
    <fz-stat-box></fz-stat-box>
  </div>
</div>
